export default __webpack_public_path__ + "static/media/charlie.f1b5afd5.webp";